export default "__VITE_ASSET__8d526ba6__"